/**
 * Filters out Swedish (SV) language except for FamilyFest events
 * @param languages - Array of languages to filter
 * @param isFamilyEvent - Whether the event is a FamilyFest event
 * @returns Filtered languages array
 */
export const filterLanguagesByEventType = (languages, isFamilyEvent) => {
    if (!languages)
        return [];
    // If it's a FamilyFest event, return all languages
    if (isFamilyEvent) {
        return languages;
    }
    // For non-FamilyFest events, filter out SV (Swedish)
    return languages.filter((lang) => {
        const code = (lang.code || '').toUpperCase();
        return code !== 'SV';
    });
};
/**
 * Filters out Swedish (SV) language for application-wide use (users, non-event contexts)
 * @param languages - Array of languages to filter
 * @returns Filtered languages array (without SV)
 */
export const filterApplicationLanguages = (languages) => {
    if (!languages)
        return [];
    // Always filter out SV for application-wide languages
    return languages.filter((lang) => {
        const code = (lang.code || '').toUpperCase();
        return code !== 'SV';
    });
};
